import { FormErrors } from 'redux-form'
import { ApiTokenFormValues } from './ApiTokenForm.types'

export default function validate (values: ApiTokenFormValues): FormErrors<ApiTokenFormValues, string> {
  const { name, apiTokens, apiTokenValue, userId } = values
  const errors: FormErrors<ApiTokenFormValues, string> = {}
  const required: string = 'common.form.validation.required'
  const alreadyUsed: string = 'common.form.validation.alreadyUsed'
  const invalid: string = 'common.form.validation.nameInvalid'
  const nameValidation = new RegExp('^[\\w\\-\\s]+$', '')

  if (apiTokens !== undefined && name !== undefined) {
    if (apiTokenValue !== undefined && apiTokens.find(apiToken => apiToken.name.toLowerCase().trim() === name.toLowerCase().trim() && apiToken.id !== apiTokenValue.id && apiToken.user_id === userId) !== undefined) {
      errors.name = alreadyUsed
    } else if (apiTokenValue === undefined && apiTokens.find(apiToken => apiToken.name.toLowerCase().trim() === name.toLowerCase().trim())) {
      errors.name = alreadyUsed
    }
  }
  if (!name) {
    errors.name = required
  }
 if(name && !nameValidation.test(name)) {
    errors.name = invalid
  }
  return errors
}
